const DEFAULT_COLOR = "#515B69";
const SELECTED_COLOR = "#50BC46";

export const getColorNavigateItem = (isSelected: boolean) =>
  isSelected ? SELECTED_COLOR : DEFAULT_COLOR;
